import { computed, action } from 'mobx';
import { StoreBase } from '../../../common/StoreBase';
import { ICustomTooltipConfiguration } from '../models';

export class CustomTooltipStore extends StoreBase {
	static componentKey: 'customTooltip' = 'customTooltip';

	@computed
	get defaultConfiguration(): ICustomTooltipConfiguration {
		return {
			useCustomTooltip: false,
			itemTemplate: {
				default: '{name}: {value}',
			},
			headerTemplate: {
				default: '{label}',
			},
		};
	}

	@computed
	get configuration(): ICustomTooltipConfiguration {
		if (this.storeContext && this.storeContext.appStore) {
			const config = this.storeContext.appStore.getComponentConfiguration(CustomTooltipStore.componentKey);
			return { ...this.defaultConfiguration, ...config };
		}
		return this.defaultConfiguration;
	}

	@action
	async initialize(): Promise<void> {

	}
}